import stringHelper from '@/scripts/helpers/string-helper';

const elementDataHelper = {
  select(dataName) {
    return document.querySelector(`[${dataName}]`);
  },

  selectAll(dataName) {
    const elementList = document.querySelectorAll(`[${dataName}]`);
    const elementArray = [];
    for (let i = 0; i < elementList.length; i++) {
      elementArray.push(elementList[i]);
    }
    return elementArray;
  },

  /**
   * Convert dataset dash-style to camelCase
   * @param {String} dashStyleString
   */
  toCamelCase(dashStyleString) {
    return stringHelper.toCamelCase(dashStyleString);
  },

  getValue(element, matchString) {
    return element.dataset[elementDataHelper.toCamelCase(matchString)];
  },
};

export default elementDataHelper;
